import styled, { css } from 'styled-components';

import { ModalPosition } from '@/constants/common';
import { flexColumn, openingEffect } from '@/styles/common';

const bottomPositionStyles = css<{ $isOpen: boolean }>`
  left: 0;
  bottom: 0;
  transform: ${({ $isOpen = false }) =>
    $isOpen ? 'translateY(0)' : 'translateY(100%)'};
`;

const centerPositionStyles = css<{ $isOpen: boolean }>`
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const halfPositionStyles = css<{ $isOpen: boolean }>`
  left: 0;
  bottom: 0;
  transform: ${({ $isOpen }) =>
    $isOpen ? 'translateY(0)' : 'translateY(100%)'};
  transition: transform 0.2s linear;
`;

const positionConfig = (position: ModalPosition) => {
  switch (position) {
    case 'bottom':
      return bottomPositionStyles;
    case 'center':
      return centerPositionStyles;
    case 'bottom-half':
      return halfPositionStyles;

    default:
      return css``;
  }
};

export const ModalWrapper = styled.div<{
  $position: ModalPosition;
  $isOpen: boolean;
  $transition?: string;
}>`
  position: fixed;
  ${flexColumn}
  align-items: center;
  gap: 20px;
  background: var(--bg-main);
  border-radius: ${({ $position }) =>
    $position === 'bottom' || $position === 'bottom-half'
      ? '14px 14px 0px 0px'
      : '14px'};

  z-index: 55;
  overflow: hidden;

  ${openingEffect()}
  ${({ $position }) => positionConfig($position)};

  ${({ $transition }) =>
    $transition &&
    css`
      transition: ${$transition} !important;
    `}
`;
